export default __webpack_public_path__ + "d7b406011e41537383ecb792d7d3dd9f.png";